import React from 'react'
import { Button, Row, Col, Form, Input, Label } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalLiquidacion = (props) => {

    const {
        loadingPayment,
        modal,
        toggle,
        handleInputChangeLiquided,
        saveLiquided,
        listPayMethod,
        validatesaveLiquided,
        amount_liquided,
        id_method_pay,
        amount_liq
    } = props;

    const liq = Number(amount_liq);
    const liquided = Number(amount_liquided);
    const diff = liq - liquided;


    const {
        id_method_pay_valid,
        amount_liquided_valid,
    } = validatesaveLiquided;

    return (
        <Dialog
            header={"Liquidar Saldos"}
            visible={modal}
            onHide={toggle}
            closable={false}
            maskClassName="custom-total-mask"


            modal
            style={{ width: "650px" }}
            headerStyle={{
                backgroundColor: '#0f172a',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0f172a', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            appendTo="self"
            className="dialog-change-right"
            draggable={false}
            footer={
                <div className="d-flex justify-content-end gap-2">
                    <Button
                        disabled={loadingPayment}
                        color="secondary"
                        type="button"
                        onClick={saveLiquided}
                    >
                        {
                            loadingPayment ? <>
                                <i className="fa fa-spinner fa-spin mr-1"></i>
                                {"Actualizando..."}
                            </> : "Autorizar"
                        }
                    </Button>
                    <Button
                        disabled={loadingPayment}
                        color="danger"
                        type="button"
                        onClick={toggle}
                    >
                        Cancelar
                    </Button>
                </div>
            }
        >
            <Form className="theme-form pt-2" role="form">
                <Row className="align-items-stretch">
                    <Col md="3" className="d-flex justify-content-center align-items-center border-end">
                        <div className="side-lock-wrapper-2">
                            <img
                                src={require("../../assets/images/blog/password.svg")}
                                alt="user"
                                className="side-lock-icon"
                            />
                        </div>
                    </Col>

                    <Col md="9">
                        <Row className="g-3 mb-3">
                            <Col md="8">
                                <Label className="form-label-sm">Método de Pago</Label>
                                <Input
                                    type="select"
                                    name="id_method_pay"
                                    value={id_method_pay}
                                    invalid={id_method_pay_valid}
                                    onChange={handleInputChangeLiquided}
                                    className="form-control form-control-sm custom-input"
                                >
                                    <option value={0}>Selecciona una opción</option>

                                    {
                                        listPayMethod.length > 0 &&
                                        listPayMethod.map(pm => {
                                            if (pm.name !== "CREDITO") {
                                                return (
                                                    <option
                                                        key={'method-' + pm.id_pay_method}
                                                        value={pm.id_pay_method}
                                                    >
                                                        {pm.abbreviation} - {pm.name}
                                                    </option>
                                                )
                                            }
                                        })
                                    }
                                </Input>
                            </Col>
                            <Col md="4">
                                <Label className="form-label-sm">Monto</Label>
                                <Input
                                    type="number"
                                    name="amount_liquided"
                                    value={amount_liquided}
                                    invalid={amount_liquided_valid}
                                    placeholder="$ 0.0"
                                    step="any"
                                    className="form-control form-control-sm custom-input"
                                    onChange={handleInputChangeLiquided}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col md="12" className="text-center pt-2">
                                <div className="pay-total-wrapper" >
                                    <div className={diff === 0 ? "pay-status show pay-green " : "pay-status show pay-orange "} >
                                        <i className={diff === 0 ? `fa fa-check-circle` : `fa fa-dollar`}></i>
                                        <div className="pay-text">
                                            {diff < 0 && (
                                                <div>
                                                    Cambio $ {Math.abs(diff).toLocaleString("en-US", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                            )}
                                            {diff > 0 && (
                                                <div>
                                                    Faltan $ {diff.toLocaleString("en-US", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                            )}
                                            {diff === 0 && (
                                                <div>
                                                    $ 0.00
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Dialog>
    )
}











